module.exports = __webpack_public_path__ + "static/media/logo.e2382054.png";